const g = require('globals')
const _ = require('underscore')
const log = require('log').create('pro analytics')  

const available_events = [
    {
        cat: 'Spotlight',
        events: ['clicked'],
    },
    {
        cat: 'Portfolio',
        events: ['viewed'],
    },
    // {
    //     cat: 'Intro Video',
    //     events: ['played'],
    // },
]

const already_sent_events = []

function sendProEvent(category, action) {
    // only on mapped pages
    if (! g.MAPPED) return

    // only in the browser
    if (typeof window === 'undefined') return

    // only if google analytics is installed
    if (! window.ga) return

    const tracking_tag = `${category}:${action}`

    // don't send duplicate events
    if (_.contains(already_sent_events, tracking_tag)) return

    // verify this event is valid
    const cat = _.findWhere(available_events, { cat: category })
    if (! cat) return
    if (! _.contains(cat.events, action)) return

    // log and send the event
    log('pro event', category, action)
    window.ga('send', 'event', category, action)

    // mark the event as sent
    already_sent_events.push(tracking_tag)
}

module.exports = {
    sendProEvent,
}
